import * as moment from "moment";
import "moment/locale/is";

export default moment;
